import React from 'react'
import { 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  CircularProgress,
  Box,
  Typography
} from '@mui/material'
import { useInvestmentContext } from '../contexts/InvestmentContext'
import { useSidebarState } from 'react-admin'

export function InvestmentSelector() {
  const {
    currentInvestment,
    userInvestments,
    setCurrentInvestment,
    loading
  } = useInvestmentContext()
  const [, setSidebarState] = useSidebarState()

  if (loading) {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <CircularProgress size={20} />
        <Typography variant="body2">Ładowanie inwestycji...</Typography>
      </Box>
    )
  }

  if (userInvestments.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Brak dostępnych inwestycji
      </Typography>
    )
  }

  if (userInvestments.length === 1) {
    return (
      <Typography variant="h6" color="primary">
        {currentInvestment?.panel_display_label || currentInvestment?.name || userInvestments[0].panel_display_label || userInvestments[0].name}
      </Typography>
    )
  }

  return (
    <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
      <InputLabel>Inwestycja</InputLabel>
      <Select
        value={currentInvestment?.id || ''}
        onChange={(e) => {
          const investment = userInvestments.find(inv => inv.id === e.target.value)
          if (investment) {
            setCurrentInvestment(investment)
            setSidebarState(false) // Auto-zamknij menu po wyborze inwestycji
          }
        }}
        label="Inwestycja"
      >
        {userInvestments.map((investment) => (
          <MenuItem key={investment.id} value={investment.id}>
            {investment.panel_display_label || investment.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}